import React from 'react'

window.onload=function(){
const hamburger = document.querySelector(".hamburger");
const navMenu = document.querySelector(".nav-menu");

hamburger.addEventListener("click", mobileMenu);

function mobileMenu() {
    hamburger.classList.toggle("active");
    navMenu.classList.toggle("active");
}
}

const Navbar = () => {
    return (
        <header class="header-new">
        <nav class="navbar-new">
            <a href="/home" class="nav-logo"><b>Skyler Basco</b></a>

                <ul className="nav-menu">
                <li className="nav-item">
                    <a href="/home" className="nav-link">Home</a>
                </li>

                <li className="nav-item">
                    <a href="/about" className="nav-link">About</a>
                </li>

                <li className="nav-item">
                    <a href="/videos" className="nav-link">Videos</a>
                </li>

                <li className="nav-item">
                    <a href="/projects" className="nav-link">Projects</a>
                </li>

                <li className="nav-item">
                    <a href="/resources" className="nav-link">Resources</a>
                </li>

                </ul>
                <div class="hamburger">
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
            </div>
        </nav>
        </header>
    )
}



export default Navbar